import type { JiraNavigationItemTypeKey } from '@atlassian/jira-relay/src/__generated__/simpleNavigationTab_businessTabs.graphql';

export const SUMMARY_ROUTES = new Set(['classic-business-summary']);

export const BOARD_ROUTES = new Set(['classic-business-board']);

export const LIST_ROUTES = new Set(['classic-business-list']);

export const TIMELINE_ROUTES = new Set(['classic-business-timeline']);

export const CALENDAR_ROUTES = new Set(['classic-business-calendar']);

export const FORMS_ROUTES = new Set(['classic-business-form', 'classic-business-form-builder']);

export const APPROVALS_ROUTES = new Set(['classic-business-approvals']);

export const ATTACHMENTS_ROUTES = new Set(['classic-business-attachments']);

export const PAGES_ROUTES = new Set(['project-pages']);

export const ISSUES_ROUTES = new Set(['issue-navigator']);

export const REPORTS_ROUTES = new Set([
	'classic-business-reports-overview',
	'legacy-all-reports',
	'legacy-reports-configure',
	'legacy-reports-average-age-report',
	'legacy-reports-created-vs-resolved-report',
	'legacy-reports-pie-report',
	'legacy-reports-recently-created-report',
	'legacy-reports-resolution-time-report',
	'legacy-reports-single-level-group-by-report',
	'legacy-reports-time-since-report',
	'legacy-reports-time-tracking-report',
	'legacy-reports-developer-workload-report',
	'legacy-reports-version-workload-report',
	'legacy-reports-workload-pie-report',
]);

export const COMPONENTS_ROUTES = new Set(['project-components']);

export const SHORTCUTS_ROUTES = new Set(['classic-business-shortcut']);

export const ARCHIVE_ROUTES = new Set(['archive-issues']);

export const ITEM_TYPE_KEY_TO_ROUTES = new Map<JiraNavigationItemTypeKey, Set<string>>([
	['SUMMARY', SUMMARY_ROUTES],
	['BOARD', BOARD_ROUTES],
	['LIST', LIST_ROUTES],
	['CALENDAR', CALENDAR_ROUTES],
	['TIMELINE', TIMELINE_ROUTES],
	['APPROVALS', APPROVALS_ROUTES],
	['FORMS', FORMS_ROUTES],
	['PAGES', PAGES_ROUTES],
	['ATTACHMENTS', ATTACHMENTS_ROUTES],
	['ISSUES', ISSUES_ROUTES],
	['COMPONENTS', COMPONENTS_ROUTES],
	['REPORTS', REPORTS_ROUTES],
	['ARCHIVED_ISSUES', ARCHIVE_ROUTES],
]);
